import { Component, OnDestroy, OnInit, Inject } from "@angular/core";
import {
  AlertController,
  ToastController,
  LoadingController,
  NavController,
  Loading
} from "ionic-angular";
import { AuthService } from "../../app/services/auth.service";
import { Store } from "@ngrx/store";
import { AppState } from "../../app/models/app.state";
import { Subscription } from "rxjs/Subscription";
import { TranslateService } from "@ngx-translate/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ENV_VARS } from "../../app/environment-variables/environment-variables.module";
import { TwoFactorPinPage } from "../two-factor-pin.page/two-factor-pin.page";

@Component({
  selector: "login-page",
  templateUrl: "login.page.html"
})
export class LoginPage implements OnInit, OnDestroy {
  loginForm: FormGroup;
  loadingOptions: {
    dismissOnPageChange: boolean;
    content: string;
  };
  loading: Loading;
  userSubscription: Subscription;
  adUrl: string = 'https://diaprofil-hcp.zitelab.eu/api/azure-ad-sas/redirect';
  constructor(
    public navCtrl: NavController,
    public alertCtrl: AlertController,
    private toastCtrl: ToastController,
    public auth: AuthService,
    public store: Store<AppState>,
    public loadingCtrl: LoadingController,
    private translate: TranslateService,
    private fb: FormBuilder,
    @Inject(ENV_VARS) public envVars
  ) {
    this.loginForm = this.fb.group({
      userName: [
        null,
        Validators.compose([Validators.required, Validators.minLength(4)])
      ],
      password: [
        null,
        Validators.compose([Validators.required, Validators.minLength(4)])
      ]
    });
  }

  modelChanged(newObj) {
    console.log(newObj);
  }

  ngOnInit() {
    this.loadingOptions = {
      dismissOnPageChange: true,
      content: this.translate.instant("GENERIC_UI.LOGGING_IN_MSG")
    };
    this.loading = this.loadingCtrl.create(this.loadingOptions);
  }

  ngOnDestroy() {
    if (this.userSubscription !== undefined) {
      !this.userSubscription.closed && this.userSubscription.unsubscribe();
    }
  }

  presentToast(errorMessage) {
    const toast = this.toastCtrl.create({
      message: errorMessage,
      dismissOnPageChange: true,
      position: "middle"
    });
    toast.present();
  }

  showLoginError(msg) {
    msg = this.translate.instant(msg);
    this.loading.dismiss();
    // We have to reset this.loading as it has been dismissed;
    this.loading = this.loadingCtrl.create(this.loadingOptions);
    this.loginForm.controls["password"].setValue("");
    this.alertCtrl
      .create({
        message: msg,
        title: this.translate.instant("GENERIC_UI.ERROR_ALERT_HEADER"),
        buttons: ["OK"]
      })
      .present();
  }

  login(userName = null, password = null) {
    userName =
      userName !== null ? userName : this.loginForm.controls["userName"].value;
    password =
      password !== null ? password : this.loginForm.controls["password"].value;
    this.loading.present();
    this.auth
      .login(userName, password, "Practitioner")
      .subscribe((res: any) => {
        if (res.challenge_url) {
          this.auth
            .initiateTwoFactorSession(res.challenge_url)
            .subscribe(result => {
              this.navCtrl.setRoot(TwoFactorPinPage, result);
            });
        }
        if (res.otp_auth_url) {
          this.navCtrl.setRoot(TwoFactorPinPage, res);
        }
      }, this.showLoginError.bind(this));
  }

  redirectToADLogin() {
    window.open(`${this.envVars.API_URL}${this.envVars.AD_URL_PATH}`, "_self");
  }

  quickLogin() {
    this.login(
      this.envVars.QUICK_LOGIN_USER_NAME,
      this.envVars.QUICK_LOGIN_PASSWORD
    );
  }

  showForgottenPasswordAlert() {
    this.alertCtrl
      .create({
        title: this.translate.instant(
          "LOGIN_PAGE.FORGOTTEN_PASSWORD_ALERT.HEADER"
        ),
        message: this.translate.instant(
          "LOGIN_PAGE.FORGOTTEN_PASSWORD_ALERT.MESSAGE"
        ),
        buttons: ["OK"]
      })
      .present();
  }

  showBypassButtons() {
    return this.auth.envVars.ENABLE_DEBUGGING === "YES";
  }
}



// WEBPACK FOOTER //
// ./src/pages/login.page/login.page.ts